$(document).ready(() =>{

    /**
     *
     * @param $btn {jQuery}
     */
    const enableSocialShare = ($btn) => {
        const url = ($btn.data('url') ?? "").toString();
        const windowWidth = parseInt($btn.data('window-width') ?? 640);
        const windowHeight = parseInt($btn.data('window-height') ?? 480);
        if(!url){
            return;
        }
        const windowLeft = (screen.width / 2) - (windowWidth / 2);
        const windowTop = (screen.height / 2) - (windowHeight / 2);

        $btn.click((event) => {
            event.preventDefault();

            window.open(url, 'm40_sharer', 'top=' + windowTop + ',left=' + windowLeft + ',toolbar=0,status=0,width=' + windowWidth + ',height=' + windowHeight);

            return false;
        })
    }

    $(".social-share-btn").each((index, element) => {
        enableSocialShare($(element));
    });
});